import styled, { css, StyledComponent } from '@xstyled/styled-components'
import { variant, breakpoints } from '@xstyled/system'
import { wait, slideInFromTop, fadeIn } from './animations'
import proportion from '@/modules/utils/proportion'

export const TitleConfirmation = styled.h1`
  font-family: title;
  font-size: ${proportion(76, 'handheld')};
  ${breakpoints({
    md: css`
      font-size: ${proportion(76, 'desktop')};
    `,
    xl: css`
      font-size: 40px;
    `,
  })}
  line-height: 40px;
  text-transform: uppercase;
  margin: 40px 0 10px;
  text-align: center;

  ${variant({
    variants: {
      light: css`
        color: #000000;
      `,
      dark: css`
        color: #ffffff;
      `,
    },
  })}
`
const getFullHeightMobile = () => {
  const isServer = typeof window === 'undefined'
  if (isServer) {
    return null
  }
  return window.innerHeight
}
export const MobileFormContainer = styled.div`
  display: flex;
  align-content: flex-end;
  /* height: 100vh; */
  height: ${getFullHeightMobile()}px;
`

export const MobileFormContainerInner = styled.div`
  height: 70vh;
  left: 0;
  position: absolute;
  bottom: 20px;
  right: 0;
  z-index: 6;
`

export const Line = styled.div`
  position: absolute;
  top: 10px;
  right: 0px;
  width: 30px;
  height: 1px;
  transform: translateX(40px);

  ${variant({
    variants: {
      light: css`
        background: #000;
      `,
      dark: css`
        background: #ffffff;
      `,
    },
  })}
`

export const ConfirmationWrapperMobile = styled.div`
  text-align: center;
`

const varMainCont = variant({
  default: 'light',
  prop: 'variant',
  variants: {
    dark: css`
      background-color: #000;
      color: #fff;
    `,
    light: css`
      background-color: #fff;
      color: #000;
    `,
  },
})

export const Container: StyledComponent<
  'div',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 90px 40px 40px 40px;
  font-size: ${proportion(16, 'handheld')};
  height: 100%;
  ${breakpoints({
    md: css`
      height: initial;
      font-size: ${proportion(32, 'desktop')};
      min-height: 550px;
      max-height: initial;
      min-width: 460px;
      overflow: none;
    `,
  })}
  ${varMainCont}
`

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  position: absolute;
  max-width: 534px;
  max-height: 552px;
  animation: ${slideInFromTop} 1.3s ease-in-out;
`

export const InnerContainer = styled.div`
  max-width: 352px;
  width: 100%;
`

export const HeadingSeperateLine = styled.div`
  border-bottom: 1px solid black;
`

export const NavContainer = styled.div`
  position: relative;
  justify-content: flex-end;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  animation: ${wait} 2s linear, ${fadeIn} 1.3s ease-in-out 2s;
`

const NavLinkVariant = variant({
  default: 'light',
  prop: 'variant',
  variants: {
    dark: css`
      color: light;
    `,
    light: css`
      color: dark;
    `,
  },
})

export const NavLink: StyledComponent<
  'button',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: title;
  font-size: ${proportion(30, 'handheld')}; /* {(48 / 750) * 100}vw = 6.4vw */
  ${breakpoints({
    md: css`
      font-size: ${proportion(18, 'desktop')};
    `,
    xl: css`
      font-size: 18px;
    `,
  })}
  ${NavLinkVariant}
  padding: 0;
  text-transform: uppercase;
`

export const DetailsForm = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: ${proportion(30, 'handheld')};
  margin-bottom: 50px;
  ${breakpoints({
    md: css`
      font-size: ${proportion(16, 'desktop')};
      margin-bottom: 0;
    `,
    xl: css`
      font-size: 16px;
    `,
  })}
  justify-content: center;
  margin-top: 2rem;
`

const FormGroupInputVariant = variant({
  default: 'light',
  prop: 'variant',
  variants: {
    dark: css`
      border-bottom: 1px solid #fff;
      &.error {
        border-bottom: 1px solid #aa0000;
      }
      color: #fff;
      input {
        color: #fff;
      }
      &.validated {
        border-color: decoration;
      }
    `,
    light: css`
      border-bottom: 1px solid #999;
      &.error {
        border-bottom: 1px solid #aa0000;
      }
      &.validated {
        border-color: decoration;
      }
      color: #000;
      input {
        color: #000;
      }
    `,
  },
})

/* eslint-disable indent */
export const FormGroup: StyledComponent<
  'div',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.div`
  position: relative;
  width: 100%;
  height: 32px;
  margin-bottom: 24px;
  ${FormGroupInputVariant}
  &.left {
    flex: 1.5;
    margin-right: 20px;
  }
  &.right {
    flex: 2.9;
  }
`
/* eslint-enable indent */

export const Response = styled.p`
  font-size: ${proportion(30, 'handheld')};
  padding-top: 30px;
  ${breakpoints({
    md: css`
      font-size: ${proportion(14, 'desktop')};
    `,
  })}
`
export const FormLabel = styled.span`
  position: absolute;
  pointer-events: none;
  display: block;
  left: 0;
  top: 10px;
  white-space: nowrap;
  transition: 0.3s top ease-in-out;
  text-transform: uppercase;
  font-size: 12px;
  color: #999;
`

export const HorizontalDivider = styled.div`
  display: flex;
  width: 100%;
`

export const AgreeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  width: 100%;
  .checkbox {
    cursor: pointer;
    margin-right: 10px;
    &.error {
      box-shadow: 0px 0px 0px 1px rgba(170, 0, 0, 1);
    }
  }
`

const PrivacyLinkVariant = variant({
  default: 'dark',
  prop: 'variant',
  variants: {
    dark: css`
      color: #fff;
      &:before {
        background-color: #fff;
      }
    `,
    light: css`
      color: #000;
      &:before {
        background-color: #000;
      }
    `,
  },
})

export const PrivacyLink: StyledComponent<
  'a',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.a`
  display: inline-block;
  position: relative;
  &:before {
    bottom: 0;
    content: '';
    height: 0.1rem;
    left: 0;
    position: absolute;
    transform: scaleX(0);
    transform-origin: left;
    transition: all 0.2s ease-in-out;
    width: 100%;
  }
  &:hover:before {
    transform: scaleX(1);
  }
  ${PrivacyLinkVariant}
`

export const ErrorMessage = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background-color: #337f65;
  color: #fff;
  height: 40px;
  font-size: ${proportion(25, 'handheld')}; /* {(48 / 750) * 100}vw = 6.4vw */
  ${breakpoints({
    md: css`
      font-size: ${proportion(12, 'desktop')};
    `,
    xl: css`
      font-size: 12px;
    `,
  })}
  align-items: center;
  justify-content: center;
`
